import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { Portal } from 'react-overlays';
import { fixDate } from '../../../utilities/dateTime';
import './../fields.css';

class DateField extends React.Component {
    CalendarContainer = ({ children }) => {
        const el = document.getElementById('calendar-portal');

        return <Portal container={el}>{children}</Portal>;
    };

    render() {
        const {
            input,
            selectedDate,
            placeholder,
            intl,
            hideErrors,
            meta: { touched, error, warning },
            disabled,
            minDate,
            maxDate
        } = this.props;
        let initialValue = input.value && typeof input.value === 'object' ? input.value : null;
        if (selectedDate) {
            initialValue = moment(fixDate(selectedDate));
        }

        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);
        if (disabled) {
            return (
                <div className="text-field date-field">
                    <div className="field-placeholder">{placeholderContent}</div>
                    <i className="material-icons calendar-icon">calendar_today</i>
                    <span className="disabled-input">{selectedDate ? moment.utc(selectedDate).format('MM/DD/YYYY') : null}</span>
                    <span className="validation-message" />
                </div>
            );
        }

        return (
            <div className="date-field">
                {input.value && <div className="field-placeholder">{placeholderContent}</div>}
                <i className="material-icons calendar-icon">calendar_today</i>
                <DatePicker
                    placeholderText={placeholderContent}
                    selected={initialValue}
                    onChange={input.onChange}
                    dateFormat="MMM D, YYYY"
                    {...{ minDate, maxDate }}
                    popperContainer={this.CalendarContainer}
                    customInput={<input type="text" {...{ ...input, value: initialValue }} />}
                />
                {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
            </div>
        );
    }
}

DateField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {}
};

DateField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(DateField);



// WEBPACK FOOTER //
// ./src/components/fields/date/index.jsx